// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDnVTaKsE-6sogkhC5rxT9xP6t6PHX7eQ4",
  authDomain: "autonomous-graphics.firebaseapp.com",
  projectId: "autonomous-graphics",
  storageBucket: "autonomous-graphics.appspot.com",
  messagingSenderId: "996796880183",
  appId: "1:996796880183:web:6a99e338bba941f30a36b2",
  measurementId: "G-L7Z2MWD20V"
};

// Initialize Firebase
const app       = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db        = getFirestore(app);

export default db;

